import { SVG, SVGProps } from './svg'

export function IconMinus(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M5.5 13a.5.5 0 0 1-.5-.5v-1c0-.3.2-.5.5-.5h13c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-13Z" />
    </SVG>
  )
}
